import * as actionTypes from 'actions';

const initialState = {
  customers: [],
  customersLoading: false
};

const deviceSubStatusSummaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FIND_CUSTOMER_DEVICE_SUB_STATUS_COUNTS_PENDING: {
      return {
        ...state,
        customers: initialState.customers,
        customersLoading: initialState.customersLoading
      };
    }

    case actionTypes.FIND_CUSTOMER_DEVICE_SUB_STATUS_COUNTS_FULFILLED: {
      return {
        ...state,
        customers: action.payload.data.result,
        customersLoading: false
      };
    }

    default: {
      return state;
    }
  }
};

export default deviceSubStatusSummaryReducer;
